import React from 'react'

function Faq() {
  return (
    <div className="container">
  <div className="howitworks"> 
    <div className="hero-text" style={{"padding":"20px"}}>
      <div className="row">
        <div className="offset-md-3 col-md-6  ">
          <div className=" about-title " style={{"margin-top":"25px"}}>
            <h1 className="about-text1 ">FAQ</h1>
          </div>
        </div>
        <div className="col-md-12" style={{"margin-top":"0px","padding":"10px"}}>
          <div className="about-content">
            <b>When can I opt for a Personal Loan?.</b><br /><br />
            A Personal Loan can be used for weddings, education, travel, medical, or any other general purposes. You can take a Personal Loan when you need money to fund an event or an emergency.<br /><br />
            <b>What is the minimum and maximum loan amount offered?</b><br /><br />
            GetCredit provides you loans up to ₹ 30 Lakh.<br /><br />
            <b>Does GetCredit give loan all over India ?</b><br /> <br />
            Yes, GetCredit helps you to get a loan in any part of India.<br /><br />
            <b>Is CIBIL score required to get loan on GetCredit?</b><br /> <br />
            CIBIL score is not required to get a loan from GetCredit.  <br /><br />
            <b>What is the condition of getting a Personal loan from GetCredit?</b><br /><br />
            To apply for Personal loan, customer<br /><br />
            • Should be an Indian citizen,<br />
            • Should have valid e-mail address and a mobile number,<br />
            • Should have a valid residential address proof Aadhaar Card.<br />
            • Personal Bank account with an access to Net Banking.<br /><br />
            <b>If I do not have any of the documents from the proposed list of documents on the application? </b><br /><br />
            As per company policies to apply for our Personal loan, possessing at least one of the mentioned documents is mandatory.<br /><br />
            <b>Can an existing customer re-apply for a Personal loan?</b><br /><br />
            Yes, anyone can apply for a personal personal loan, but it is subject to conditions based on the credit history of the applicant.<br /><br />
            <b>What is the interest rate for the loan offered?</b><br /><br />
            The general rate of interest is 7.5%. We also offer based on various factors such as loan amount, credit score, etc., and may differ for different customers.<br /><br />
            <b>Is there any loan pre-closure charges?</b><br /><br />
            No, there is no loan pre-closure charges. <br /><br />
            <b>What is the time taken for sanction and disbursal of loan amount?</b><br /><br />
            It takes only a few minutes for the loan to be approved. It is our best endeavor to disburse the loan amount within a day after the KYC is done.<br /><br /><br />
            <b>How to apply for Personal loan? Or what is the process of Personal loan?</b><br /><br />
            Follow these simple steps to apply for a Personal loan.<br />
            • Register with us on our webpage www.GetCredit.org<br />
            • Complete the application by filling in your personal details.<br />
            • After you get the approval.
            • Sign your application on our Website and your process is complete.<br /><br />
            <b>In what format can Aadhaar Card be uploaded?</b><br /> <br />
            The documents can be uploaded in JPEG, JPEG, PDF and PNG formats.<br /><br />
            <b>What is the mode of Loan Repayment?</b><br /> <br />
            Mode of Loan Repayment-<br /> <br />
            • PAY ON GetCredit.org WEBSITE
            • Visit www.GetCredit.org and click on 'PAY EMI' button.<br />
            • Fill the required loan details and enter monthly installment.<br />
            • Choose a debit card or net banking option to make your payment.<br />
            • Enter transaction password or OTP sent to your registered mobile number, to complete the transaction<br />
            • Save the receipt for future use. Kindly check your E-mail and SMS for payment confirmation. <br /><br />
            <b>Can the Loan Amount and Tenure be selected manually?</b><br /> <br />
            Yes, the loan tenure and amount can be selected manually. But this loan amount and tenure are subject to selection eligibility conditions.<br /><br />
            <b>What is otp?</b><br /> <br />
            OTP is the one-time password, also known as a one-time PIN, one-time authorization code, or dynamic password, is a password that is valid for only one login session or transaction, on a computer system or other digital device, which is your login password also to login into the portal whenever you want to apply for a loan.  <br /><br />
            <b>What if the OTP is not received on the Mobile ?</b><br /> <br />
            If OTP is not received on mobile, please wait for 1 minute, if still not received OTP, then click on resend button. <br /><br />
            <b>Who can login to customer portal? </b><br /> <br />
            Only a user who had sign up as a customer can only login to customer poratl. <br /><br />
            <b>Who can login to DSA portal? </b><br /> <br />
            Only a user who had sign up as a DSA user can only login to customer poratl. <br /><br />
            <b>Can a customer login to DSA Portal? </b><br /> <br />
            No, a customer can not login to DSA Portal. <br /><br />
            <b>Can a DSA user login to customer Portal? </b><br /> <br />
            No, a DSA user can not login to customer Portal. <br /><br />
            <b>What needs to be done if someone leaves the loan application mid-way but wants to complete the same after a few days?</b><br /> <br />
            You can complete your loan application anytime within 7 days of your registration.<br /><br />
            <b>Will the Loan Amount be disbursed 7 days a week?</b><br /> <br />
            Yes, the loan amount will be disbursed on all working days.<br /><br />
            <b>When would be the repayment start date?</b><br /> <br />
            The repayment date will start from the day of the next month on which the loan was issued.<br /><br />
            <b>How much repayment I have to pay every month?</b><br /> <br />
            You will pay the repayment in the form of EMI which was calculated while applying for the loan.<br /><br />
            <b>Can I re-pay my loan early?</b><br /> <br />
            Yes. The process of early re-payment is applicable after 6 months.<br /><br />
            <b>How can You contact the customer support?</b><br /> <br />
            You can contact our customer support through the contact form or you can mail us your enquiry at contact@GetCredit.org.<br /><br />
            <b>Will you recieve any verification call from the company?</b><br /> <br />
            No, All the process is online and the verification process is handled automatically by the backend team.<br /><br />
            <b>What is the APR of loan on GetCredit? </b><br /> <br />
            The APR of loan on GetCredit is 8% which calculating formula is <br /> APR = [2 x Number of Payments per Year x Total Finance Charges] / [Original Loan Proceeds x Total Number of Payments + 1]
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  )
}

export default Faq